// extracted by mini-css-extract-plugin
export default {"banner":"CookieBanner_banner__qMVj8","actions":"CookieBanner_actions__8FLkP","primary":"CookieBanner_primary__uDhAR","secondary":"CookieBanner_secondary__+2yk0"};